import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { SearchX } from 'lucide-react';

export default function CompanyFundsEmpty() {
  return (
    <Card className="mt-4">
      <CardContent className="p-6">
        <motion.div 
          className="flex flex-col items-center justify-center py-8 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <SearchX className="h-12 w-12 text-gray-400" />
          </motion.div>
          <motion.h3 
            className="mt-4 text-lg font-medium"
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.3 }}
          >
            No related funds found
          </motion.h3>
          <motion.p 
            className="text-sm text-muted-foreground"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.3 }}
          >
            No other funds were found for this company.
          </motion.p>
        </motion.div>
      </CardContent>
    </Card>
  );
}
